export const uiSchema = t => {
  return {
    personalEmail: {
      "ui:title": t("SECONDARY_EMAIL_ADDRESS"),
    },
    homePhone: {
      "ui:title": t("HOME_PHONE_NUMBER"),
    },
    mobilePhone: {
      "ui:title": t("MOBILE_PHONE_NUMBER"),
    },
  };
};
